import { Pipe, type PipeTransform } from '@angular/core';
import {
    toAddressFormat,
    type AddressMode,
    ADDRESS_MODE,
} from '@quipex/shared/utils';

@Pipe({
    name: 'qpxAddress',
})
export class AddressPipe implements PipeTransform {
    transform(
        value: unknown,
        mode: AddressMode = ADDRESS_MODE.Full,
        fallbackMode?: AddressMode
    ): string {
        const address = toAddressFormat(value, mode);

        return (
            address ||
            (fallbackMode ? toAddressFormat(value, fallbackMode) : '')
        );
    }
}
